export default {"src":"/_next/static/media/promotion-tag-icon.91faabb9.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};